export default __webpack_public_path__ + "static/media/Super_Marka_2023.3053421b.png";